import {customElement, bindable, autoinject, containerless} from "aurelia-framework";
//import {bindingMode as BindingMode} from "aurelia-binding";
import "./save-cancel-row.css";

@containerless
@autoinject
@customElement('save-cancel-row')
export class SaveCancelRow {

    @bindable save: () => void;
    @bindable cancel: () => void;
    // as save-enabled
    @bindable saveEnabled: boolean = true;

    onSave() {
        if (this.save && this.saveEnabled) {
            this.save();
        }
    }

    onCancel() {
        if (this.cancel) {
            this.cancel();
        }
    }
}